import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_align_space_between.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconAlignSpaceBetween = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlignSpaceBetween;
